export default __webpack_public_path__ + "static/media/other-grey.c31ab812.svg";